export const jp = {
    navbar: {
        choose_language: '希望の言語を選択してください！！',
        lang: '言語',
        list: 'メニューリスト',
        home: 'ホーム',
        product: '商品',
        category: 'カテゴリー',
        products: '商品一覧',
        request: '注文リクエスト',
        series: 'シリーズ',
        character: 'キャラクター',
        search: '商品を検索...',
        keyword: 'キーワードを入力してください...',
        cart: 'カート',
        login: 'ログイン',
        register: '登録',
        dropdown: {
            request: 'カスタム注文をリクエスト',
            list_order: '注文リスト',
            wishlist: 'ほしい物リスト',
            profile: 'プロフィール',
            address: '住所',
            logout: 'ログアウト',
            cart: 'マイカート',
            cart_detail: '詳細'
        },
        message: 'メッセージ',
        empty: {
            title: 'カートは空です',
            desc: '今すぐ商品を追加しましょう！'
        },
        stores: {
            tokopedia: 'Tokopedia',
            booth: 'Booth',
            offline_store: '実店舗'
        }
    },
    section: {
        custom: {
            heading: 'ワールドワイド',
            title: 'カスタムリクエスト注文',
            description:
                '日本を主な供給国として、世界中からの輸入注文を受け付けています。詳細はお問い合わせください！！',
            button: '詳細情報'
        },
        categories: {
            title: 'カテゴリー'
        },
        news: {
            title: 'ニュース & イベント'
        },
        view: 'すべて見る',
        read: '続きを読む'
    },
    login: {
        title: 'ログイン',
        email: 'メールアドレス',
        password: 'パスワード',
        cta: 'サインイン',
        remember: 'ログイン状態を保存',
        forgot: 'パスワードをお忘れですか？',
        or: 'または次でログイン',
        register: 'アカウントをお持ちですか？',
        register_desc:
            '今すぐ登録して、限定商品にアクセスしましょう！！',
        register_cta: '今すぐ登録',
        account: 'アカウント'
    },
    register: {
        title: '登録',
        first: '名',
        last: '姓',
        email: 'メールアドレス',
        phone: '電話番号',
        password: 'パスワード',
        confirm: 'パスワード（確認）',
        cta: 'サインアップ',
        login: 'アカウントをお持ちですか？',
        login_desc: '買い物を続けるにはログインしてください',
        login_cta: 'ここからログイン'
    },
    product: {
        title: '全商品',
        price: '価格',
        filter: {
            newest: '新着順',
            most_buy: '人気順',
            popular: '注目順',
            discount: '割引',
            pre_order: '予約注文',
            ready_stock: '在庫あり',
            lowest_price: '価格が安い順',
            highest_price: '価格が高い順',
        },
        cta: 'さらに読み込む',
        empty: {
            title: '商品が見つかりません',
            desc: '申し訳ありませんが、お探しの商品は現在入手できません'
        }
    },
    shorts: {
        title: 'ショート動画をチェック',
        cta: 'すべてのショート動画を見る'
    },
    search: {
        filter: {
            title: '商品を絞り込む',
            close: '閉じる',
            min: '最低価格',
            max: '最高価格',
            category: 'カテゴリー',
            series: 'シリーズ',
            character: 'キャラクター',
            condition: '状態',
            other: 'その他',
            stock: '在庫あり',
            order: '予約注文',
            apply: 'フィルターを適用',
            clear: 'フィルターをクリア'
        },
        sort: {
            title: '並び替え',
            relevant: '関連度順',
            newest: '新着順',
            price_high: '価格が高い順',
            price_low: '価格が安い順'
        }
    },
    request: {
        title: 'カスタムリクエスト注文',
        search: '注文を検索',
        product_url: '希望する商品のリンクを入力してください！',
        brief: 'うーん、それはどんな商品ですか？',
        brief_placeholder:
            'Xiaokenがご希望の商品を理解できるように、以下の項目に入力してください。',
        name: '商品名',
        name_placeholder: '商品名を入力',
        price: '価格',
        quantity: '数量',
        quantity_placeholder: '合計数量',
        shipping: 'どこに発送しますか？',
        notice: '注意',
        notice_desc:
            '送料、レート、支払総額などのカスタムリクエスト注文の詳細をWhatsAppでお知らせします。電話番号が正しいことを確認してください。',
        cta: 'リクエストを送信',
        slider_title:
            'どこからでも買い物はリンクをコピーするだけ！',
        slider_desc:
            'Amazon、楽天など、さまざまなマーケットプレイスの商品を購入できます。欲しい商品のリンクをコピーして、上のフィールドに貼り付けるだけです。',
        history: '履歴',
        guide: 'ガイド',
        status: {
            all: 'すべて',
            approved: '承認済み',
            pending: '保留中',
            canceled: 'キャンセル済み'
        },
        reset: 'フィルターをリセット',
        history_number: '注文番号',
        history_link: '商品リンク',
        history_chat: '出品者とチャット',
        history_empty: '履歴がありません',
        history_empty_desc: "まだカスタム注文がありません。注文を追加しましょう！！"
    },
    product_page: {
        product: '商品',
        detail: {
            title: '商品詳細',
            category: 'カテゴリー',
            sku: 'SKU',
            min_order: '最小注文数',
            condition: '状態',
            condition_new: '新品',
            condition_used: '中古',
            status: {
                duration: '期間',
                days: '日'
            },
            character: 'キャラクター',
            stock: '在庫',
            stock_out: '在庫切れ',
            size: 'サイズ (縦x横x高さ)',
            weight: '重量',
            tags: 'タグ'
        },
        select: '選択',
        quantity: '数量',
        order_notes: '注文メモ',
        notes_placeholder: '注文メモをここに記入してください...',
        add_cart: 'カートに追加',
        wishlist: 'ほしい物リスト',
        checkout_now: '今すぐチェックアウト',
        desc: '商品説明',
        share: '共有',
        similar: '類似商品',
        recent: '最近見た商品',
        interest: 'おすすめ商品'
    },
    checkout: {
        title: '注文のチェックアウト',
        add: '商品を追加',
        shipment: '配送',
        payment: '支払い',
        status: 'ステータス',
        cart: {
            title: 'ショッピングカート',
            selected: '選択済み',
            empty: 'カートは空です',
            empty_desc: '今すぐ商品を追加しましょう！',
            cta: '配送に進む'
        },
        table: {
            product: '商品',
            variant: 'バリエーション',
            weight: '重量',
            quantity: '数量',
            action: 'アクション',
            shopping_total: '買い物合計',
            total_weight: '総重量',
            alert: '続行するには商品を削除してください',
            notes: 'メモ',
            stock_out: '在庫切れ',
            back: '買い物を続ける'
        }
    },
    summary: {
        title: '注文概要',
        coupon: 'クーポンコード',
        shop_total: '買い物合計',
        ship_cost: '送料',
        insurance: '保険料',
        discount: '割引',
        pack: "梱包手数料",
        gov_tax: '政府税',
        payment_fee: '支払手数料',
        grand: '総計',
        apply_coupon: 'クーポンを適用',
        coupon_applied: 'クーポン適用済み',
        items: '点',
        free_shipping: '送料無料',
        select_expedition: '配送業者を選択してください',
        tooltip: {
            free_shipping: '合計購入金額が以下の金額を超えると<b>送料無料</b>になります ',
            insurance_fee: '保険付きの商品は、以下の手数料がかかります',
            minimum: '最低',
            tax_fee: '税抜き商品には、以下の手数料がかかります',
            paypal_fee: '<b class="capitalize">{method}</b>に合わせて追加料金を加算します。手数料は',
            final_payment: '最終支払額に基づきます'
        }
    },
    shipment: {
        title: '配送',
        address: '配送先住所',
        page: 'マイアドレス',
        empty: '住所が登録されていません',
        empty_desc: '注文を完了するには、少なくとも1つの住所を追加してください',
        card: {
            type: 'タイプ',
            primary: 'メイン',
            selected: '選択中',
            receipt: '受取人',
            country: '国',
            province: '都道府県',
            city: '市区町村',
            address: '住所',
            detail: '詳細住所',
            postal: '郵便番号',
            cta: '別の住所を選択'
        },
        form: {
            list: '住所リスト',
            add: '新しい住所を追加',
            update: '住所を更新',
            type: '住所タイプ',
            receipt: '受取人名',
            email: '受取人メールアドレス',
            phone: '電話番号',
            country: '国',
            province: '都道府県',
            city: '市区町村',
            postal: '郵便番号',
            address: '住所',
            detail: '建物名 / 階数 / 部屋番号',
            main: 'メイン住所として設定',
            yes: 'はい',
            no: 'いいえ',
            cta: '住所を追加',
            cta2: '住所を更新',
            notice_email:
                '発送および配送に関する情報は、このメールアドレスに送信されます',
            notice_phone:
                '国際形式で入力してください。例: 819012345678'
        },
        expedition: {
            title: '配送業者を選択',
            sent: '発送元',
            destination: '宛先',
            estimate: '見積もり',
            days: '日'
        },
        method: '支払方法',
        notes: '配送メモ',
        notes_placeholder: '配送に関するメモをここに記入してください...',
        cta: '今すぐ支払う',
        insurance: {
            title: '配送保険',
            active: '保険を有効にする',
            fee: '保険料',
            desc: '購入した商品の1つに保険が必要です。より安全な配送のために',
            yes: 'はい',
            no: 'いいえ'
        }
    },
    payment: {
        guide: '支払いガイド',
        title: '支払注文',
        close: '終了まで',
        invoice: '請求書を確認',
        days: '日',
        hour: '時間',
        minute: '分',
        second: '秒',
        expirate: '支払期限切れ',
        notice: 'ご注文ありがとうございます。お支払期限までに注文の支払いを完了していただくようお願いします。下のボックスに支払証明をアップロードすることを忘れないでください。',
        upload: '支払証明をアップロード',
        uploaded: 'あなたの支払証明',
        total: '支払総額'
    },
    status: {
        expirate: '支払時間が終了しました',
        expirate_desc:
            '支払期限が切れました。新しい注文を行ってください',
        expirate_cta: '新しい注文を行う',
        reject: '支払いは無効です',
        reject_desc: '新しい支払証明をアップロードしてください',
        reject_cta: '支払証明をアップロード',
        pending: '支払いは処理中です',
        pending_desc:
            'しばらくお待ちください。チームが支払いを確認します',
        pending_cta: '他の商品を購入',
        paid: 'おめでとうございます。支払いが承認されました',
        paid_desc:
            'XiaokenShopでご注文いただきありがとうございます。できるだけ早く注文を処理します。',
        paid_cta: '注文を追跡'
    },
    order: {
        title: '注文履歴',
        search: '注文を検索',
        empty: '注文リストは空です',
        empty_desc: '新しい注文を追加してください！',
        cta: '商品を追加',
        status: {
            all: 'すべて',
            process: '処理中',
            success: '完了',
            cancel: 'キャンセル',
            failed: '失敗',
            reset: 'フィルターをリセット'
        },
        card: {
            price: '価格',
            shipping: '配送先',
            detail: '取引詳細',
            total: '支払総額',
            product: '商品合計',
            cancel: '注文をキャンセル',
            help: '注文ヘルプ',
            pay: '今すぐ支払う',
            again: 'もう一度注文する'
        },
        detail: {
            title: '取引詳細',
            viewmore: 'もっと見る',
            number: '注文番号',
            date: '注文日',
            order: '商品詳細',
            shipping: '配送詳細',
            expedition: '配送業者',
            address: '配送先住所',
            payment: '支払詳細',
            method: '支払方法',
            total: '買い物合計',
            shipping_cost: '送料',
            gov: '政府税',
            payment_fee: '支払手数料',
            grand: '支払総額',
            discount: '割引'
        }
    },
    wishlist: {
        title: 'マイウィッシュリスト',
        empty: 'ウィッシュリストは空です',
        empty_desc: '商品を探索して、お気に入りの商品を見つけましょう！'
    },
    profile: {
        title: 'プロフィールを更新',
        verify: 'アカウントを確認',
        email_not: 'メールアドレス未確認',
        email_yes: 'アカウント確認済み',
        first: '名',
        last: '姓',
        dob: '誕生日',
        phone: '電話番号',
        password: 'パスワード',
        confirm: 'パスワード（確認）',
        cta: 'プロフィールを更新'
    },
    forgot: {
        title: 'パスワードをお忘れですか？',
        desc: 'メールアドレスを入力してください。パスワードリセット用のリンクをお送りします。'
    },
    reset: {
        title: 'パスワードをリセット',
        desc: 'パスワードをリセットするには、以下の項目に入力してください',
        new: '新しいパスワード',
        confirm: '新しいパスワード（確認）',
        cta: 'パスワードを変更'
    },
    footer: {
        address: '住所',
        shopping: {
            head: 'ショッピング',
            home: 'ホーム',
            request: 'カスタム注文',
            all_product: '全商品',
            discount: '割引商品'
        },
        about: {
            head: '私たちについて',
            about: '概要',
            news: 'ニュース & イベント',
            tnc: '利用規約',
            privacy: 'プライバシーポリシー'
        },
        support: {
            head: 'サポート',
            shop_guide: 'ショッピングガイド',
            faq: 'よくある質問',
            help: 'お問い合わせ'
        },
        payment: '対応決済',
        store: '店舗',
        follow: 'フォローする'
    }
}
